module.exports = __webpack_public_path__ + "static/media/joinicon.abd32693.svg";